import type { AuthenticatedUser } from "~/models/auth";
import React from "react";

interface Props {
  children: React.ReactNode;
  user: AuthenticatedUser | null;
}
export default function PageWithNavigation({ children }: Props) {
  return (
      <div >
          {children}
      </div>
  );
}
